import { Autocomplete, TextField, Typography } from '@mui/material';
import { useGetCountryAndStateOptionsQuery, useLazyGetCountryAndStateOptionsQuery } from '../Api/countryApi';
import { forwardRef, memo, useEffect, useImperativeHandle, SyntheticEvent, RefObject, useState, useRef } from 'react';

interface StateOption {
  label: String;
  value: String;
}

interface StateProps {
  name?: string;
  disabled?: boolean;
  errormessage?: string;
  size?: 'small' | 'medium';
  value?: string;
  error?: boolean;
  label?: string;
  required?: boolean;
  onStateChange?: (event: SyntheticEvent<Element, Event>, option: StateOption | null, name?: string, statesList?: StateOption[]) => void;
  inputRef?: RefObject<HTMLInputElement>;
  stateList?: StateOption[];
  setStateList: (varArray: any[]) => void;
}

export interface StateRef {
  fetchStates: () => Promise<StateOption[]>;
  focus: () => void;
}

const State = forwardRef<StateRef, StateProps>(
  ({ name, disabled, errormessage, size, value, error, label, required, onStateChange, inputRef, setStateList }, ref) => {
    const [statefn] = useLazyGetCountryAndStateOptionsQuery();
    const [statesLists, setstatesLists] = useState<StateOption[]>([]);
    const autocompleteRef = useRef<any>(null);
    const textFieldInputRef = useRef<HTMLInputElement>(null);
    const Change = async (e: SyntheticEvent<Element, Event>, option: StateOption | null) => {
      if (onStateChange) {
        onStateChange(e, option, name, statesLists);
      }
    };
    console.log(statesLists, 'statedata');

    useImperativeHandle(ref, () => ({
      fetchStates: async () => {
        const data = await statefn({ codetype: 'IndiaState' }, true);
        console.log(data, 'data');

        return data.data || [];
      },
      focus: () => {
        if (textFieldInputRef.current) {
          textFieldInputRef.current.focus();
        } else if (autocompleteRef.current) {
          const inputElement = autocompleteRef.current.querySelector('input');
          if (inputElement) {
            inputElement.focus();
          }
        }
      },
    }));

    useEffect(() => {
      const dd = async () => {
        const data = await statefn({ codetype: 'IndiaState' }, true);
        console.log(data, 'data');
        setstatesLists(data.data || []);
        setStateList(data.data || []);
      };
      dd();
    }, []);

    return (
      <>
        <Autocomplete
          id={name}
          size={size}
          disabled={disabled}
          ref={autocompleteRef}
          getOptionLabel={(option) => String(option.label)}
          value={statesLists?.find((option) => option?.value.toLowerCase() === value?.toLowerCase()) || null}
          onChange={Change}
          options={statesLists || []}
          renderInput={(params) => <TextField required={required} inputRef={ref} error={error} {...params} label={label} />}
        />
        <Typography
          sx={{
            marginTop: '2px',
            marginLeft: '10px',
            marginBottom: '0px',
            fontSize: '11px',
            color: 'danger.main',
          }}
        >
          {errormessage}
        </Typography>
      </>
    );
  }
);

export default memo(State);
